var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('span',{staticClass:"spin-a d1"},[_vm._v("a")]),_c('span',{staticClass:"spin-a d2"},[_vm._v("a")]),_c('span',{staticClass:"spin-a d3"},[_vm._v("a")])])
}]

export { render, staticRenderFns }